/* eslint-disable react/require-default-props,react/no-unused-prop-types */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import { Link } from '../../../Link/index';

import { ROUTE_USER_PROFILE_PAGE } from '../../../../../ReduxStorage/routeActions';

export class ProfileHeaderNav extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    profilePage: ImmutablePropTypes.map,
    page: PropTypes.string,
    pages: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        path: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        component: PropTypes.any,
      })
    ).isRequired,
    updateProfilePageShareShow: PropTypes.func,
    updateProfilePageSetPageDirty: PropTypes.func,
    updateProfilePageSetWarningCallback: PropTypes.func,
  };

  navLinkOnClick = () => {
    const { user, updateProfilePageShareShow } = this.props;

    // update share link
    updateProfilePageShareShow(user.get('profileName'), false);
  };

  render() {
    const { user, page, pages } = this.props;
    const pageToRender = pages.filter((page_) => page_.get('isVisible')(user));

    return (
      <nav
        className="profile-nav"
        ref={(el) => {
          if (el) {
            this.profileNav = el;
          }
        }}
        id="profile-nav"
        role="navigation"
      >
        <ul className="profile-nav-menu">
          {pageToRender.map((pageData) => {
            return (
              <li key={`nav-tab-${pageData.get('path')}`}>
                <Link
                  className={classnames('nav-tab', {
                    'nav-tab-current': pageData.get('path') === page,
                  })}
                  data-text={pageData.get('label')}
                  to={{
                    type: pageData.get('type', ROUTE_USER_PROFILE_PAGE),
                    params: {
                      page: pageData.get('path'),
                      profileName: user.get('profileName'),
                    },
                  }}
                  onClick={this.navLinkOnClick}
                >
                  {pageData.get('label')}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}
